import {useEffect} from 'react';

export const useSetScrollToZero = (valid) => useEffect(() => {(document.scrollingElement ? document.scrollingElement : document.documentElement).scrollTop = 0;}, [valid])
